import { render, staticRenderFns } from "./categoryManage.vue?vue&type=template&id=74fa534f&scoped=true&"
import script from "./categoryManage.vue?vue&type=script&lang=js&"
export * from "./categoryManage.vue?vue&type=script&lang=js&"
import style0 from "./categoryManage.vue?vue&type=style&index=0&id=74fa534f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fa534f",
  null
  
)

export default component.exports